/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen_monitor': {
    width: 16,
    height: 16,
    viewBox: '0 0 49.28 52.96',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" _fill="none" _stroke="#f0f1f2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M23.71 51.76H1V1h43.66v30.87"/><path pid="1" _fill="none" _stroke="#f0f1f2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.51 26.38l8.34-11.75 8.13 9.43 8.88-12.52"/><circle pid="2" cx="36.4" cy="43.8" r="3.2" _fill="#f0f1f2"/><path pid="3" d="M46.21 37v5.11A9.81 9.81 0 0136.4 52h0a9.81 9.81 0 01-9.81-9.81V37M48.28 37.04H24.52" _fill="none" _stroke="#f0f1f2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></g>'
  }
})
